import { FormlyFieldConfig } from '@ngx-formly/core';
import type { FormlyHookFn } from './formly-hook-fn.type';
import { getChildObject } from './form-data.utility';
import { startWith, takeUntil } from 'rxjs/operators';
import { MeterCollarService } from '@intellio/shared/services';
import { MeterCollar } from '@intellio/shared/models';
import { combineLatest } from 'rxjs';
import {
  mapMeterCollarMakeOptions,
  mapMeterCollarModelOptions,
} from './meter-collar-options.utility';

export const filterMeterCollarsHook = (
  destroyed$,
  meterCollarService: MeterCollarService
): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    const p = field.parent;
    var meterCollarData: MeterCollar[] = [];

    meterCollarService.getMeterCollars().subscribe((data) => {
      meterCollarData = data.data;
    });
    const breakerSizeObject = getChildObject(p, 'meterCollarBreakerSize');
    const breakerSizeFormField = field.form.get(breakerSizeObject.key);
    const ampsObject = getChildObject(p, 'meterCollarAmps');
    const ampsFormField = field.form.get(ampsObject.key);
    const makeObject = getChildObject(p, 'meterCollarMake');
    const makeFormField = makeObject.formControl;

    combineLatest(
      breakerSizeFormField.valueChanges,
      ampsFormField.valueChanges,
      makeFormField.valueChanges.pipe(startWith(makeFormField.value))
    )
      .pipe(takeUntil(destroyed$))
      .subscribe(([breakerSizeValue, ampValue, makeValue]) => {
        if (field.form.status !== 'DISABLED') {
          const modelObject = getChildObject(p, 'meterCollarModel');

          var filteredData = meterCollarData;
          if (breakerSizeValue != null) {
            filteredData = filteredData.filter(
              (m) => m.circuitBreakerAmps == breakerSizeValue
            );
          }
          if (ampValue != null) {
            filteredData = filteredData.filter(
              (m) => m.serviceAmpRating == ampValue
            );
          }

          makeObject.props.options = mapMeterCollarMakeOptions(filteredData);
          const selectedMake = typeof makeValue === 'string' ? makeValue : null;
          const modelOptions = selectedMake
            ? mapMeterCollarModelOptions(filteredData, selectedMake)
            : [];

          modelObject.props.options = modelOptions;

          if (
            modelObject.formControl.value &&
            !modelOptions.some(
              (option) => option.value === modelObject.formControl.value
            )
          ) {
            modelObject.formControl.setValue(null);
          }
        }
      });
  };
};

export const filterMeterCollarModelsByMakeHook = (
  destroyed$,
  meterCollarService: MeterCollarService
): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    const p = field.parent;
    const makeObject = getChildObject(p, 'meterCollarMake');
    const modelObject = getChildObject(p, 'meterCollarModel');

    combineLatest(
      meterCollarService.getMeterCollars(),
      makeObject.formControl.valueChanges.pipe(
        startWith(makeObject.formControl.value)
      )
    )
      .pipe(takeUntil(destroyed$))
      .subscribe(([data, makeValue]) => {
        if (field.form.status !== 'DISABLED') {
          const selectedMake = typeof makeValue === 'string' ? makeValue : null;
          const options = selectedMake
            ? mapMeterCollarModelOptions(data.data ?? [], selectedMake)
            : [];

          modelObject.props.options = options;

          if (
            modelObject.formControl.value &&
            !options.some(
              (option) => option.value === modelObject.formControl.value
            )
          ) {
            modelObject.formControl.setValue(null);
          }
        }
      });
  };
};
